import { Checkbox, Menu, MenuButton, MenuItem, MenuList } from '@aloft/toolkit-sui';
import { FormControl, FormLabel } from '@aloft/toolkit-sui/chakra';

type Props = {
  label: string;
  prefix: string;
  value: string[];
  onChange: (values: string[]) => void;
};

const BUTTON_STYLE: React.CSSProperties = {
  height: '32px',
  minWidth: '140px',
  padding: '0 8px',
  border: '1px solid var(--chakra-colors-gray-300)',
  borderRadius: 'var(--chakra-radii-md)',
  fontSize: 'var(--chakra-fontSizes-sm)',
  backgroundColor: 'white',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '4px',
  textAlign: 'left',
  width: '100%',
};

export const RatingMultiSelect = ({ label, prefix, value, onChange }: Props) => {
  const toggle = (v: string) => {
    onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  };

  const displayText =
    value.length === 0
      ? 'Any'
      : [...value]
          .sort((a, b) => Number(a) - Number(b))
          .map((v) => `${prefix}${v}`)
          .join(', ');

  return (
    <FormControl size="sm" width="initial">
      <FormLabel size="sm" mb={1}>
        {label}
      </FormLabel>
      <Menu closeOnSelect={false}>
        <MenuButton as="button" style={BUTTON_STYLE}>
          <span>{displayText}</span>
          <span style={{ fontSize: '10px', opacity: 0.6 }}>▼</span>
        </MenuButton>
        <MenuList minWidth="140px">
          {[1, 2, 3, 4, 5, 6].map((n) => (
            <MenuItem key={n} onClick={() => toggle(String(n))}>
              <Checkbox isChecked={value.includes(String(n))}>
                {prefix}
                {n}
              </Checkbox>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </FormControl>
  );
};
